class WindowFunc {
    getTop(current = null) {
      try {
        let topWindow = window.top;
        topWindow.canSet = "canSet";
        if (!topWindow.ecodeSDK) {
          return window.self;
        }
        return topWindow;
      } catch (error) {
        if (current === null) {
          current = window.self;
        }
        if (current.setTopWindow) {
          return current.setTopWindow;
        } else {
          try {
            let parentWindow = current.parent;
            parentWindow.canSet = "canSet";
            return this.getTop(parentWindow);
          } catch (error) {
            current.setTopWindow = current;
            return current;
          }
        }
      }
    }
    getParent() {
      try {
        let parent = window.parent;
        if (!parent.ecodeSDK) {
          return window.self;
        }
        return parent;
      } catch (error) {
        return window.self;
      }
    }
  }
  
  export default new WindowFunc();


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/util/public/getWindow.js